
import Cookies from 'js-cookie'
const TokenKey = 'x-access-token'
const expireIn = window.localStorage.getItem('token-expireIn');
const tokenExpireIn = (expireIn ? Number(expireIn) * 1000 : 24 * 60 * 60 * 1000) + 28800000;
const inFifteenMinutes = new Date(new Date().getTime() + tokenExpireIn);
const hostName = window.location.hostname.indexOf('sdland-sea.com') > -1 ? ["SDLAND-SEA.COM", '.sdland-sea.com'] : ["SDLANDSEA.NET", '.sdlandsea.net'];
export function getToken() {
  if (window.location.host.indexOf(hostName) != -1) {
    return Cookies.get(TokenKey, { domain: hostName })
  } else {
    return Cookies.get(TokenKey)
  }
}

export function setToken(token) {
  if (window.location.host.indexOf(hostName) != -1) {
    return Cookies.set(TokenKey, token, { expires: inFifteenMinutes, path: '/', domain: hostName });
  } else {
    return Cookies.set(TokenKey, token, { expires: inFifteenMinutes })
  }
}

export function removeToken() {
  if (window.location.host.indexOf(hostName) != -1) {
    return Cookies.remove(TokenKey, { path: '/', domain: hostName })
  } else {
    return Cookies.remove(TokenKey);
  }
}

const ExpiresInKey = 'Admin-Expires-In'
export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey)
}